export const TestIds = {
  PopupCloseIconButtonRoot: 'popupCloseIconButtonRoot',
} as const;

export const A11Y_LABEL_TRANS_NAMESPACE = 'ariaLabels';
export const A11Y__LABEL_TRANS_KEY = 'PopupCloseIconButton_AriaLabel';
export const A11Y_LABEL_TRANS_DEFAULT_VAL = 'Back to site';
